import script from "./Show.vue?vue&type=script&setup=true&lang=ts"
export * from "./Show.vue?vue&type=script&setup=true&lang=ts"

import "./Show.vue?vue&type=style&index=0&id=7bf27669&scoped=true&lang=css"
script.__scopeId = "data-v-7bf27669"

export default script